import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../../services/request.service';

@Component({
  selector: 'app-delete-request-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './delete-request-modal.component.html',
  styleUrl: './delete-request-modal.component.scss',
})
export class DeleteRequestModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() requestDeleted = new EventEmitter<{ note: string }>();

  note: string = '';
  type: number | null = null;
  causes: any[] = [];

  constructor(private requestService: RequestService) {}

  cancel(): void {
    this.cancelled.emit();
  }

  confirm() {
    const note = this.causes.find(c=> c.id == this.type).name + ' ' + this.note;
    this.requestDeleted.emit({ note: this.note });
  }

  ngOnInit() {
    this.requestService.getCauses('ANN').subscribe(result => {
      this.causes = result;
    })
  }
}
